import * as Config from '../../../../../config';
import React from 'react';
import { connect } from "react-redux";

import Menu from '../../../tab-bar/Menu';
import IconCompactPlayer from '../../../svg/IconCompactPlayer';

function ConnectedTabBarMenus({ isConnected, isTablet }) {
  return (
    <>
      { (isConnected && isTablet) && <IconCompactPlayer id={`menu_compact`} size={20} className={`topbutton`} style={{padding: `10px 7px`, position: `absolute`, right: 305 }} onClick={window.compact_toggle} /> }
      <Menu to={`/home`} order={1} title={`Discover`} description={`Browse all genres by top tracks, DJ sets, DJ charts, ${Config.capAppName()} playlists, trending artists, trending labels and trending genres.`} />
      <Menu to={`/genres`} title={`Genres`} order={2} description={`Browse by genre: View top tracks in genre, ${Config.capAppName()} playlists in genre, trending artists in genre and trending labels in genre. Filter by favorite genres, featured releases in genre, all tracks in genre, all releases in genre and all playlists in genre.`} />
      <Menu to={`/dig-deeper`} order={3} title={`Dig Deeper`} description={`Discover our curated collection of electronic gems.`} />
    </>
  )
}

const TabBarMenus = connect(
  state => ({
    isConnected: state.isConnected,
    isTablet: state.layoutTablet
  })
)(ConnectedTabBarMenus);

export default TabBarMenus;
